import { Component, Input, Output, EventEmitter } from '@angular/core';
import Rutas from 'src/app/Models/Base/rutas';
import { AppStateService } from '../../Services/AppState/app-state.service';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
  standalone: true,
  
})
export class IframeComponent {

  @Input() url: string = 'about:blank';
  @Output() load = new EventEmitter<boolean>(false);
  constructor(
    private appState: AppStateService
  ) { 
    if(!!this.appState.urlIframe.length){
      this.url = this.appState.urlIframe;
    }
    else{
      this.appState.router.navigate([Rutas.DASHBOARD])
    }
  }

  onLoad(){
    this.load.emit(true);
  }
 
}
